var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatListBulleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_2158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5V17.5H21V19.5H9ZM9 13.5V11.5H21V13.5H9ZM9 7.5V5.5H21V7.5H9ZM5 20.5C4.45 20.5 3.97917 20.3042 3.5875 19.9125C3.19583 19.5208 3 19.05 3 18.5C3 17.95 3.19583 17.4792 3.5875 17.0875C3.97917 16.6958 4.45 16.5 5 16.5C5.55 16.5 6.02083 16.6958 6.4125 17.0875C6.80417 17.4792 7 17.95 7 18.5C7 19.05 6.80417 19.5208 6.4125 19.9125C6.02083 20.3042 5.55 20.5 5 20.5ZM5 14.5C4.45 14.5 3.97917 14.3042 3.5875 13.9125C3.19583 13.5208 3 13.05 3 12.5C3 11.95 3.19583 11.4792 3.5875 11.0875C3.97917 10.6958 4.45 10.5 5 10.5C5.55 10.5 6.02083 10.6958 6.4125 11.0875C6.80417 11.4792 7 11.95 7 12.5C7 13.05 6.80417 13.5208 6.4125 13.9125C6.02083 14.3042 5.55 14.5 5 14.5ZM5 8.5C4.45 8.5 3.97917 8.30417 3.5875 7.9125C3.19583 7.52083 3 7.05 3 6.5C3 5.95 3.19583 5.47917 3.5875 5.0875C3.97917 4.69583 4.45 4.5 5 4.5C5.55 4.5 6.02083 4.69583 6.4125 5.0875C6.80417 5.47917 7 5.95 7 6.5C7 7.05 6.80417 7.52083 6.4125 7.9125C6.02083 8.30417 5.55 8.5 5 8.5Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatListBulleted);
export default __webpack_public_path__ + "static/media/format_list_bulleted.ba02efcf9e803bd122f08312a4e108fe.svg";
export { ForwardRef as ReactComponent };